import { openBoardGamesEvent } from '@/helpers'
import type { BoardGamesEventOsraConfigInterface } from '@/map-phaser-new/interfaces'

export const boardGamesEventOsra: BoardGamesEventOsraConfigInterface = {
  textureKey: 'board_games_event_osra_image',
  positionX: 2155,
  positionY: 1430,
  notificationX: 2155,
  notificationY: 1315,
  depth: 3,
  origin: 0.5,
  routeConfig: (/* router */): Promise<void> => openBoardGamesEvent(),
  inputConfig: {
    useHandCursor: true,
  },
  outlineConfig: {
    textureKey: 'board_games_event_osra_image_outline',
    depth: 3,
  },
}

export const iceAndFireEventOsra: BoardGamesEventOsraConfigInterface = {
  textureKey: 'ice_and_fire_event_osra_image',
  positionX: 2155,
  positionY: 1430,
  notificationX: 2155,
  notificationY: 1315,
  depth: 3,
  origin: 0.5,
  routeConfig: (/* router */): Promise<void> => openBoardGamesEvent(),
  inputConfig: {
    useHandCursor: true,
  },
  outlineConfig: {
    textureKey: 'ice_and_fire_event_osra_image_outline',
    depth: 3,
  },
}
